import { useNavigate, useLocation, Outlet, useParams } from "react-router-dom";
import {
  ArrowLeftIcon,
  MailNotificationIcon,
  PhoneIcon,
  UserIcon,
} from "../components/Icons";
import { useAppContext } from "../context/AppContext";
import { useFetch } from "../hooks/useFetch";
import { admin_get_all_users } from "../constants/apis";
import type { FullRegistrationFormType as User } from "../schemas/FullRegistrationFormSchema";

const assign_options = [
  { label: "Assign Task", value: "" },
  { label: "Yogesh", value: "yogesh" },
  { label: "Akash", value: "akash" },
  { label: "Charlie Brown", value: "charlie_brown" },
];

export default function AdminCustomerProfileLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { uid } = useParams<{ uid: string }>();
  const { adminJWTToken } = useAppContext();

  // TODO: replace with RTK query or
  // the users profile been already fetched can we only filter them out
  //  based on the uid
  // Fetch company details
  const { data, loading } = useFetch<User>(
    `${admin_get_all_users}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${adminJWTToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ uid }),
    },
    uid,
  );

  const pathParts = location.pathname.split("/").filter(Boolean);

  // Remove "admin"
  const filteredParts = pathParts.filter((part) => part !== "admin");
  const breadcrumbParts = filteredParts
    .filter((part) => isNaN(Number(part))) // remove numbers
    .map((part) =>
      part.replace(/-/g, " ").replace(/\b\w/g, (char) => char.toUpperCase()),
    );

  return (
    <section className="mt-10 space-y-8">
      {/* Header */}
      {/* <div className="card flex items-center gap-3">
        <button
          className="px-4 py-1 border-2 border-gray-200 text-[#344054] font-medium rounded-lg flex items-center gap-1"
          onClick={() => navigate(-1)}
        >
          <ArrowLeftIcon className="size-4" />
        </button>
        <div className="flex items-center gap-4">
          <h2 className="text-lg font-medium text-gray-800">
            {loading ? (
              <span className="animate-pulse bg-gray-200 h-5 w-32 inline-block rounded"></span>
            ) : (
              <>
                {data?.company_name ?? "Unknown Company"}{" "}
                <span className="text-base font-medium text-gray-500 ml-2">
                  › {breadcrumbParts.slice(1).join(" › ")}
                </span>
              </>
            )}
          </h2>
          <div className="w-[150px]">
            <select className="input-new">
              {assign_options.map((el) => (
                <option value={el.value} key={el.label}>
                  {el.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div> */}

      <div className="card flex items-start justify-between gap-6">
        {/* Left Section */}
        <div className="flex items-start gap-4">
          {/* Back Button */}
          <button
            className="px-4 py-1 border-2 border-gray-200 text-[#344054] font-medium rounded-lg flex items-center gap-1"
            onClick={() => navigate(-1)}
          >
            <ArrowLeftIcon className="size-4" />
          </button>

          {/* Company Info */}
          <div className="space-y-1">
            {/* Company + Breadcrumb */}
            <h2 className="text-lg font-semibold text-gray-800">
              {loading ? (
                <span className="animate-pulse bg-gray-200 h-5 w-40 inline-block rounded"></span>
              ) : (
                <>
                  {data?.company_name ?? "Unknown Company"}
                  <span className="text-base font-medium text-gray-500 ml-2">
                    › {breadcrumbParts.slice(1).join(" › ")}
                  </span>
                </>
              )}
            </h2>

            {/* User Details */}
            {!loading && (
              <div className="flex flex-wrap items-center gap-x-6 gap-y-1 text-sm text-gray-600">
                <div className="flex items-center gap-2">
                  <UserIcon className="size-4 text-gray-400" />
                  <span>
                    {data?.first_name} {data?.last_name}
                  </span>
                </div>

                <div className="flex items-center gap-2">
                  <MailNotificationIcon className="size-4 text-gray-400" />
                  <span>{data?.work_email}</span>
                </div>

                <div className="flex items-center gap-2">
                  <PhoneIcon className="size-4 text-gray-400" />
                  <span>{data?.company_phone_number}</span>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Right Section */}
        <div className="w-[180px]">
          <select className="input-new">
            {assign_options.map((el) => (
              <option value={el.value} key={el.label}>
                {el.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Nested content */}
      <Outlet />
    </section>
  );
}
